import React, { useMemo } from 'react';

/**
 * Configuration Table is a helper component that displays the configuration of the device in use.
 * It extracts all the necessary information from the description to show it properly.
 * customName is pre-resolved by ThumbnailList and passed as a prop.
 */

const ConfigurationTable = ({ description, customName }) => {
  const parsedConfig = useMemo(() => {
    let planningName = '';
    let deviceType = '';
    let deviceSize = '';

    if (description) {
      // Normalize: remove extra spaces around dashes and remove duplicate dashes
      const normalized = description
        .replace(/\s*-\s*/g, '-') // Remove spaces around dashes
        .replace(/-+/g, '-') // Remove duplicate dashes
        .replace(/^-|-$/g, ''); // Remove leading/trailing dashes

      // Format: {NAME}-{TYPE_DEVICE}-{SIZE}-{TSP}
      const deviceTypePattern = /-(AML|FLX)-/g;
      let matches = [...normalized.matchAll(deviceTypePattern)];

      if (matches.length > 0) {
        // Use the last match to handle cases like "test-AML-AML"
        const match = matches[matches.length - 1];
        const typeStartIndex = match.index;
        const typeEndIndex = typeStartIndex + match[0].length;

        planningName = normalized.substring(0, typeStartIndex).trim();

        const deviceTypeMap = {
          AML: 'AMULET',
          FLX: 'FLX',
        };
        deviceType = deviceTypeMap[match[1]] || match[1];

        // Get the remaining part after the device type
        const remainingPart = normalized.substring(typeEndIndex);
        const remainingParts = remainingPart.split('-').filter(p => p.trim());

        deviceSize = remainingParts[0] || '';
      }
    }

    return {
      planningName,
      deviceType,
      deviceSize,
    };
  }, [description]);

  const displayName = customName || parsedConfig.planningName;

  return (
    <div className="flex w-full flex-col items-center justify-center space-y-3 text-center text-black">
      {/* Custom Name Badge */}
      {displayName && (
        <div className="w-full text-center text-sm font-bold text-gray-900">{displayName}</div>
      )}

      {/* Configuration Table - Centered */}
      <div className="flex w-full items-center justify-center">
        <table className="w-full max-w-[180px] table-fixed text-center">
          <thead>
            <tr>
              <th className="w-1/2 px-1 text-sm font-bold text-gray-900">Type</th>
              <th className="w-1/2 px-1 text-sm font-bold text-gray-900">Size</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-1 text-sm font-bold text-gray-900">
                {parsedConfig.deviceType || '-'}
              </td>
              <td className="px-1 text-sm font-bold text-gray-900">
                {parsedConfig.deviceSize || '-'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConfigurationTable;
